// components/SelfViewLabel.jsx
import React from 'react';
import { User } from 'lucide-react';

const SelfViewLabel = () => (
  <div className="absolute top-6 right-8 bg-black bg-opacity-60 px-2 py-1 rounded text-sm flex items-center">
    <User size={14} className="mr-1" />
    <span>You</span>
  </div>
)

export default SelfViewLabel;